import { MediaType, WorkItemHandlingStats } from '../models/reports.internal';
import { reduceWithSum } from '../utils/arrayUtils';
import { objectValues } from '../utils/objectUtils';

function getTotalWorkItemCounts(workItemsByMedia: Record<MediaType, WorkItemHandlingStats>): { handled: number; missed: number; } {
  const handled = reduceWithSum(objectValues(workItemsByMedia), (curr) => curr.handled);
  const missed = reduceWithSum(objectValues(workItemsByMedia), (curr) => curr.missed);

  return { handled, missed };
}

export default getTotalWorkItemCounts;